import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { colors } from '@mui/material';
import mock from 'src/utils/mock';

dayjs.extend(duration);

mock.onGet('/api/calendar').reply(200, {
  draft: [],
  events: [
    {
      id: '5e8882e440f6322fa399eeb8',
      allDay: false,
      color: colors.green['700'],
      description: 'Inform about new contract',
      end: dayjs()
        .subtract(dayjs.duration(
          { days: 6, hours: 19, minutes: 0 }
        ))
        .toDate()
        .getTime(),
      start: dayjs()
        .subtract(dayjs.duration(
          { days: 6, hours: 17, minutes: 30 }
        ))
        .toDate()
        .getTime(),
      title: 'Call Samantha'
    },
    {
      id: '5e8882eb5f8ec686220ff131',
      allDay: false,
      color: null,
      description: 'Discuss about new partnership',
      end: dayjs()
        .add(dayjs.duration(
          { days: 2, hours: 15, minutes: 30 }
        ))
        .toDate()
        .getTime(),
      start: dayjs()
        .add(dayjs.duration(
          { days: 2, hours: 12, minutes: 0 }
        ))
        .toDate()
        .getTime(),
      title: 'Meet with IBM'
    },
    {
      id: '5e8882f1f0c9216396e05a9b',
      allDay: false,
      color: null,
      description: 'Prepare docs',
      end: dayjs()
        .add(dayjs.duration(
          { days: 5, hours: 12, minutes: 0 }
        ))
        .toDate()
        .getTime(),
      start: dayjs()
        .add(dayjs.duration(
          { days: 5, hours: 8, minutes: 0 }
        ))
        .toDate()
        .getTime(),
      title: 'SCRUM Planning'
    },
    {
      id: '5e8882f6daf81eccfa40dee2',
      allDay: true,
      color: null,
      description: 'Meet with team to discuss',
      end: dayjs()
        .subtract(11, 'days')
        .startOf('day')
        .toDate()
        .getTime(),
      start: dayjs()
        .subtract(12, 'days')
        .endOf('day')
        .toDate()
        .getTime(),
      title: 'Beign SEM'
    },
    {
      id: '5e8882fcd525e076b3c1542c',
      allDay: false,
      color: colors.green['700'],
      description: 'Sorry, John!',
      end: dayjs()
        .add(dayjs.duration(
          { days: 3, hours: 7, minutes: 31 }
        ))
        .toDate()
        .getTime(),
      start: dayjs()
        .add(dayjs.duration(
          { days: 3, hours: 7, minutes: 30 }
        ))
        .toDate()
        .getTime(),
      title: 'Fire John'
    },
    {
      id: '5e888302e62149e4b49aa609',
      allDay: false,
      color: null,
      description: 'Discuss about the new project',
      end: dayjs()
        .subtract(dayjs.duration(
          { days: 6, hours: 9, minutes: 30 }
        ))
        .toDate()
        .getTime(),
      start: dayjs()
        .subtract(dayjs.duration(
          { days: 6, hours: 9, minutes: 0 }
        ))
        .toDate()
        .getTime(),
      title: 'Call Alex'
    },
    // {
    //   id: '5e88830672d089c53c46ece3',
    //   allDay: false,
    //   color: colors.green['700'],
    //   description: 'Get a new quote for the payment processor',
    //   end: dayjs
    //     .duration(
    //       { hours: 17, minutes: 30 }
    //     )
    //     .toDate()
    //     .getTime(),
    //   start: dayjs
    //     .duration(
    //       { hours: 15, minutes: 30 }
    //     )
    //     .toDate()
    //     .getTime(),
    //   title: 'Visit Samantha'
    // }
  ]
});
